<div class="form-container">
  <div class="container">
    <mat-checkbox [formControl]="formControl" [disabled]="disabled">{{label}}</mat-checkbox>
  </div>
</div>
